export function validateCard(numero: string) {

  const numeroLimpo = numero.replace(/\D/g, '');

  let soma = 0;
  let alternar = false;

  for (let i = numeroLimpo.length - 1; i >= 0; i--) {
    let n = parseInt(numeroLimpo.charAt(i), 10);

    if (alternar) {
      n *= 2;
      if (n > 9) n -= 9;
    }

    soma += n;
    alternar = !alternar;
  }

  return soma % 10 === 0;
}
